import DataTable from 'components/ui/DataTable/data-table';
import React, { FC, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useRoutineWiseSessionFeedbackQuery } from 'redux/reducers/Feedback/sessionAndModuleFeedback';
import { BiLastPage } from 'react-icons/bi';
import ViewIcon from '../../../../assets/images/icons/view.png';
interface IRoutineManagementTable {
  tableHeaders?: () => React.ReactNode;
  status: number;
  isSuperAdmin: boolean
}

const RoutineFeedBackSession: FC<IRoutineManagementTable> = ({ tableHeaders, status, isSuperAdmin }) => {
  const navigate = useNavigate();
  const { routineId } = useParams<{ routineId: string }>();
  const currentPage = localStorage.getItem('currentSession_page');
  const [pageNo, setPage] = useState(currentPage ? +currentPage : 1);
  const [pageSize, setPageSize] = useState(10);
  const { data: sessionFeedBack, isLoading: isLoadingFeedbackSession } =
    useRoutineWiseSessionFeedbackQuery({ pageNo, pageSize, routineId });
  const totalRows = sessionFeedBack?.data && sessionFeedBack?.data.length > 0 ? sessionFeedBack?.data?.[0].row_total : 0;

  const totalPages = Math.ceil(totalRows / 10);
  const canNext = pageNo < totalPages;
  const canPrevious = pageNo > 1;

  useEffect(() => {
    localStorage.setItem('currentSession_page', pageNo.toString());
  }, [pageNo]);

  useEffect(() => {
    if (currentPage) localStorage.removeItem('currentSession_page');
  }, []);

  const columns = [
    {
      Header: 'Session Name',
      accessor: (data: any, index: number) => {
        return `Session ${pageNo === 1 ? index + 1 : index + (pageNo - 1) * 10 + 1} : ${data?.course_topic?.title
          }`;
      }
    },
    {
      Header: 'Lecturer',
      accessor: (data: any) => {
        return (
          <>
            {data?.lecturer.map((lect: any) => (
              <div style={{ marginRight: '5px' }}>{lect}</div>
            ))}
          </>
        );
      }
    },
    {
      Header: 'Date',
      accessor: 'routine_date'
    },
    {
      Header: 'Action',
      accessor: (data: any, index: number) => {
        return (
          <>
            <img
              src={ViewIcon}
              onClick={() =>
                navigate(`/routine-management/${routineId}/feedback/session/${data.id}/view`, {
                  state: {
                    topic: `Session ${index + 1}: ${data.routine_session.session_name}`
                  }
                })
              }
            />

            {isSuperAdmin && <BiLastPage
              style={{ fontSize: '20px', marginLeft: 10 }}
              onClick={() => navigate(`/training/routine/${routineId}/session/${data.id}/feedback`)}
            />}
          </>
        );
      }
    }
  ];

  return (
    <>
      <div>
        <DataTable
          columns={columns}
          isLoading={isLoadingFeedbackSession}
          data={sessionFeedBack?.data || []}
          tableHeaders={tableHeaders}
          pagination={{
            canNext,
            canPrevious,
            prevPage: () => {
              if (canPrevious) {
                setPage((prev) => prev - 1);

              }
            },
            nextPage: () => {
              if (canNext) {
                setPage((prev) => prev + 1);
              }
            }
          }}
        />
      </div>
    </>
  );
};

export default RoutineFeedBackSession;
